import { useEffect, useState } from 'react'
import { serverSyncService } from '../../core/infrastructure/server-sync-service'
import type { SyncQueueItem } from '../../db/client'

export interface DiscardedNotification {
  id: string
  item: SyncQueueItem
  reason: string
  timestamp: number
}

export function useSyncNotifications() {
  const [discardedItems, setDiscardedItems] = useState<DiscardedNotification[]>([])

  useEffect(() => {
    const unsubscribe = serverSyncService.onSyncDiscard((item: SyncQueueItem, reason: string) => {
      const discarded: DiscardedNotification = {
        id: `${Date.now()}-${Math.random()}`,
        item,
        reason,
        timestamp: Date.now()
      }

      setDiscardedItems((prev) => [...prev, discarded])

      // Auto-dismiss after 10 seconds
      setTimeout(() => {
        setDiscardedItems((prev) => prev.filter((d) => d.id !== discarded.id))
      }, 10000)
    })

    return unsubscribe
  }, [])

  const dismiss = (id: string) => {
    setDiscardedItems((prev) => prev.filter((d) => d.id !== id))
  }

  return { discardedItems, dismiss }
}
